import axios from "axios";
import {downloadFile} from "../../../utils/file/download";

export class CorporateActionService {
    /**
     * Función que hace una llamada al back para consultar la lista para
     * llenar la pantalla de Ejercicios de derecho.
     * @returns {Promise<any>} Respuesta que contiene la lista de
     * contratos o regresa un error, cuando no puede consultar.
     */
    getCorporateAction() {
        return axios.get('/appapv/getCorporateAction.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una llamada al back para consultar el detalle
     * para la pantalla de ejercicios de derecho.
     * @returns {Promise<any>} Respuesta que contiene la lista de
     * contratos o regresa un error, cuando no puede consultar.
     */
    getLoanCorporateAction() {
        return axios.get('/appapv/getLoanCorporateAction.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una llamada al back para obtener los préstamos para
     * la acción de aplicar en ejercicios de derecho.
     * @param {Number} idEm Id de la emisión.
     * @returns {Promise<any>} Mensaje de éxito o error al modificar el contrato.
     */
    getSecurityCorporateAction(idEm) {
        return axios.get('/appapv/getSecurityCorporateAction.action', {
            params: {
                idEmision: idEm,
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una llamada al back para mandar correo electrónico
     * para la pantalla de ejercicios de derecho.
     * @returns Respuesta de éxito, cuando se envía el correo
     * o regresa un error, cuando no puede consultar.
     */
    sendEmailCorpAction() {
        return axios.get('/appapv/sendEmailCorpAction.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }

    /**
     * Función que hace una llamada al back para aplicar el ejercicio de derecho.
     * @returns Respuesta de éxito, cuando se envía el correo
     * o regresa un error, cuando no puede aplicarlo.
     */
    applyCorporateAction(objectCorporateAction) {
        return axios.put('/appapv/applyCorpAction.action', {}, {
            params: {
                idInfoCorporateAction: objectCorporateAction.idInfoCorporateAction ?
                    objectCorporateAction.idInfoCorporateAction : 0,
                idCorporateAction: objectCorporateAction.idCorporateAction ?
                    objectCorporateAction.idCorporateAction : 0,
                idEmision: objectCorporateAction.idEmision ?
                    objectCorporateAction.idEmision : 0,
                idEmisionNew: objectCorporateAction.idEmisionNew ?
                    objectCorporateAction.idEmisionNew : 0,
                ratio: objectCorporateAction.ratio ?
                    objectCorporateAction.ratio : 0,
                precio24Hrs: objectCorporateAction.precio24Hrs ?
                    objectCorporateAction.precio24Hrs : 0,
            }
        }).then(res => res.data);

    }

    /**
     * Función que hace una petición al back para obtener el
     * documento con el detalle de Ejercicio de derechos.
     * @returns {Promise<any>}
     */
    exportDetailCorporateAction() {
        return downloadFile('/appapv/getReportDetailCorporateActionXls.action');
    }
}
